<template>
  <button v-if="!isProd" :disabled="disabled" @click="show">Get MTX Tokens</button>
</template>

<script>
import keycodes from "../../data/keycodes"
const isProd = process.env.VUE_APP_NETWORK_ID === "1"

export default {
  props: {
    disabled: Boolean
  },

  data: () => ({
    isProd
  }),

  mounted() {
    window.addEventListener("keydown", this.onKeydown)
  },

  beforeDestroy() {
    window.removeEventListener("keydown", this.onKeydown)
  },

  methods: {
    onKeydown({ keyCode }) {
      // close zeroEx on ESC
      const zeroEx = document.querySelector("#zeroExInstant")
      if (zeroEx && keyCode === keycodes.ESC) {
        this.hide()
      }
    },

    hide() {
      document.querySelector("#zeroExInstant .zeroExInstantOverlayCloseButton > div").click()
    },

    show() {
      // TODO: create new order for mainnet
      //  - replace orderSource with generated order
      //  - replace all "0xf472..." with makerAssetData from order
      //  - change networkId to 1
      // https://0x.org/portal/generate (page hangs, wait 15s)

      // eslint-disable-next-line
      zeroExInstant.render(
        {
          availableAssetDatas: [
            "0xf47261b0000000000000000000000000f35a0f92848bdfdb2250b60344e87b176b499a8f"
          ],
          defaultSelectedAssetData:
            "0xf47261b0000000000000000000000000f35a0f92848bdfdb2250b60344e87b176b499a8f",
          additionalAssetMetaDataMap: {
            "0xf47261b0000000000000000000000000f35a0f92848bdfdb2250b60344e87b176b499a8f": {
              assetProxyId: "0xf47261b0",
              decimals: 18,
              symbol: "MTX",
              name: "Matryx",
              primaryColor: "#0f0f32"
            }
          },
          orderSource: [
            {
              senderAddress: "0x0000000000000000000000000000000000000000",
              makerAddress: "0x42023a03679a68da047d6d7e91bb432912566130",
              takerAddress: "0x0000000000000000000000000000000000000000",
              makerFee: "0",
              takerFee: "0",
              makerAssetAmount: "200000000000000000000000",
              takerAssetAmount: "285000000000000000000",
              makerAssetData:
                "0xf47261b0000000000000000000000000f35a0f92848bdfdb2250b60344e87b176b499a8f",
              takerAssetData:
                "0xf47261b0000000000000000000000000c778417e063141139fce010982780140aa0cd5ab",
              expirationTimeSeconds: "2524636800",
              feeRecipientAddress: "0x0000000000000000000000000000000000000000",
              salt: "86451538614328912945835125508239822662897277769484274794197638594300369590288",
              signature:
                "0x1c62f71b451c7d31deb37d1526be395a8e3fe7d46adee5c1223a0a9f382de26c5c039649bb928038c2c18dcdc30fd88c050ac4b2a9324badc44170607ad750714803",
              exchangeAddress: "0x4530c0483a1633c7a1c97d2c53721caff2caaaaf"
            }
          ],
          networkId: 3
        },
        "body"
      )

      this.$nextTick(() => {
        // click modal cover to close
        const overlay = document.querySelector(".zeroExInstantOverlay")
        overlay.addEventListener("click", e => {
          if (e.target.parentElement.classList.contains("zeroExInstantOverlay")) {
            this.hide()
          }
        })
      })
    }
  }
}
</script>

<style lang="scss">
.zeroExInstantResetRoot {
  svg {
    fill: none;
  }
}
</style>
